import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { MotionConfig } from "framer-motion";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { UIProvider } from "@/context/UIContext";
import Home from "@/pages/Home";
import { Impressum, Datenschutz } from "@/pages/Legal";
import ManageBooking from "@/pages/ManageBooking";
import Admin from "@/pages/Admin";

function ScrollTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

export default function App() {
  return (
    <MotionConfig reducedMotion="user">
      <UIProvider>
        <BrowserRouter>
          <ScrollTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/termin" element={<ManageBooking />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </UIProvider>
    </MotionConfig>
  );
}
